import DeleteIcon from '@assets/icons/delete.svg';
import React from 'react';
import { Button, Props as ButtonProps } from './button';
import { StyleSheet } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

export const CloseButton: React.FC<ButtonProps> = ({ children, ...rest }) => {
  const theme = useTheme();
  const buttonIconProps: Partial<ButtonProps> = children
    ? {}
    : {
        Icon: DeleteIcon,
        iconProps: {
          fill: theme.colors.primary,
          stroke: undefined,
        },
      };

  return (
    <Button
      hoverStyle={styles.hover}
      size="small"
      testID="close-button"
      type="tertiary"
      {...buttonIconProps}
      {...rest}
    >
      {children}
    </Button>
  );
};

const styles = StyleSheet.create({
  hover: {
    opacity: 0.8,
  },
});
